import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';
import { SuccessDialogComponent } from 'src/app/shared/success-dialog/success-dialog.component';
import { WaitingDialogComponent } from 'src/app/shared/waiting-dialog/waiting-dialog.component';
import { ProductService } from '../product-list.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-download-popup',
  templateUrl: './download-popup.component.html',
  styleUrls: ['./download-popup.component.scss']
})
export class DownloadPopupComponent implements OnInit {
  @ViewChildren("checkboxes") checkboxes: QueryList<ElementRef>;
selectAll: boolean = false;
selectedBrandsMap: { [key: string]: boolean } = {};
selectedBrands: string[] = [];

  action = new Subject();
  message: string;
  data: any;
  pagename: any;
  constructor(private route: ActivatedRoute, public modalRef: MDBModalRef, private productService: ProductService, private modalService: MDBModalService) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe(queryParams => {
      this.pagename = queryParams.get('page');
      console.log(this.pagename);
      this.getAllFiltersType(this.pagename)
    });


// this.brandFilterDetails.forEach((brand: string) => {
//     this.selectedBrandsMap[brand] = false;
//   });

  }


onSelectAllChange(event: any) {
  this.selectAll = event.target.checked;
  this.brandFilterDetails.forEach((brand: string) => {
    this.selectedBrandsMap[brand] = this.selectAll;
  });

  this.updateSelectedBrands();
}

onBrandChange(brand: string, event: any) {
  this.selectedBrandsMap[brand] = event.target.checked;
  this.updateSelectedBrands();

  // If any single checkbox is unchecked, uncheck "Select All"
  if (!event.target.checked) {
    this.selectAll = false;
  }
  // If all are checked, automatically check "Select All"
  else if (this.brandFilterDetails.every(b => this.selectedBrandsMap[b])) {
    this.selectAll = true;
  }
}

updateSelectedBrands() {
  this.selectedBrands = this.brandFilterDetails.filter(
    (brand) => this.selectedBrandsMap[brand]
  );

  // Send selected brands to your service (if needed live)
  this.productService.SetBrandNames(this.selectedBrands);
}



  close() {
    this.action.next('OK');
    this.modalRef.hide()
  }

  onDesigId() {

  }

  optionSelected: string = "";

  onSelect(e) {
    this.optionSelected = e.target.value
    console.log("optionSelected", this.optionSelected);
    this.productService.SetName(this.optionSelected);

  }

  brandFilterDetails: any
  getAllFiltersType(filter): any {
    this.productService.getBrandBasedOnProductType(filter).then((data) => {
      this.brandFilterDetails = data
    })

  }

  successModalRef: MDBModalRef;
  waitingModalRef: MDBModalRef;
  //optionSelected: string = "RS";


  //Array: string[] = [];
  isfrmChecked: any;
  Array: any[] = []; // Declare the array property

  // componentMethodName(event: any) {

  //   if (!event.target.checked) {

  //     this.Array.push(event.target.value)
  //   }
  //   else {
  //     const valueIndex = this.Array.findIndex(event.target.value)

  //     if (valueIndex > -1) {
  //       this.Array.splice(valueIndex, 1)
  //     }

  //   }

  //   let filteredData: string[] = [];
  
  //   this.brandFilterDetails.forEach((data) => {
  //     if (!this.Array.includes(data)) {
  //       filteredData.push(data);
  //     }
  //   });

  //   // if (isChecked) {
  //   //   this.Array.push(event.target.value)
  //   // }
  //   // else {
  //   //   let index = this.Array.indexOf(event.target.value);
  //   //   console.log("valuee",event.target.value)
  //   //   //console.log('hiiiii'+index);
  //   //   this.Array.splice(index, 1);
  //   // }
  //   // console.log(this.Array);
  //   this.productService.SetBrandNames(filteredData);
  // }

  componentMethodName(event: any) {
    if (!event.target.checked) {
      this.Array.push(event.target.value);
    } else {
      const valueIndex = this.Array.indexOf(event.target.value);
      if (valueIndex > -1) {
        this.Array.splice(valueIndex, 1);
      }
    }
  
    let filteredData: string[] = this.brandFilterDetails.filter(
      (data) => !this.Array.includes(data)
    );
  
    this.productService.SetBrandNames(filteredData);
  }

  // download(data) {
  //   let filteredData: string[] = [];
  
  //   this.brandFilterDetails.forEach((data) => {
  //     if (!this.Array.includes(data)) {
  //       filteredData.push(data);
  //     }
  //   });

  //   console.log('filtered data', filteredData);
    
  //   if (filteredData.length) {
  //     this.action.next(data);
  //   } else {
  //     alert("Atleast Select one Brand")
  //     return false
  //   }
    
  //   // this.Array = this.brandFilterDetails.slice();
  //   // if (this.Array.length == 0) {
  //   //   alert("Atleast Select one Brand")
  //   //   return false
  //   //   // 
  //   // } else {
  //   //   this.action.next(data);
  //   //   console.log("brandName" + data)
  //   // }

  // }
download(data: string) {
  if (this.selectedBrands.length > 0) {
    // Only selected brands go into payload
    console.log('Selected brands for download:', this.selectedBrands);
    this.action.next(data);
  } else {
    alert("Please select at least one brand");
  }
}
  // download(data) {
  //   let filteredData: string[] = this.brandFilterDetails.filter(
  //     (data) => !this.Array.includes(data)
  //   );
  
  //   if (filteredData.length > 0) {
  //     this.action.next(data);
  //   } else {
  //     alert("At least select one Brand");
  //   }
  // }
  downloadFile() {
    const url = 'https://ibdindents.titan.in/Stock.xlsx';
    window.open(url, '_blank');
  }

  // download(data) {
  //     this.Array = this.brandFilterDetails.slice();
  //   if (this.Array.length === 0) {
  //     alert("At least select one Brand");
  //     return false;
  //   } else {


  //     if (this.Array.length === 0) {
  //       alert("At least select one Brand");
  //       return false;
  //     }

  //     // Now you can use the filteredData array for downloading or any further processing
  //     // For example, if you want to pass it to the 'action' method, you can do this:
  //     this.action.next(data);
  //     console.log("brandName" + data);
  //   }
  // }
  // clearSelection() {
  //   this.checkboxes.forEach((element) => {
  //     element.nativeElement.checked = false;
  //   });
  // }


  selectAlls() {
    this.Array = this.brandFilterDetails.map(item => item.value);
    this.checkboxes.forEach(checkbox => checkbox.nativeElement.checked = true);
  }




}
